// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { selectValue } from "#/admin/legacy/sp-select/index.js";
import { whenSelectsReady } from "#/admin/legacy/sp-select/when-selects-ready.js";

/** Returns the behavior tool's category and strategy items with the stored choices, each resolved to a listed choice. */
export function behaviorChoices(selectItems, component) {
  return {
    categoryItems: selectItems.categories,
    strategyItems: selectItems.replacement_strategies,
    cta_category: selectValue(selectItems.categories, component.data("cta_category")),
    replacement_strategy: selectValue(selectItems.replacement_strategies, component.data("replacement_strategy")),
  };
}

/** Writes the selected category's title into each strategy whose label template names the category. */
export function relabelStrategies(categorySelect, strategySelect) {
  const item = categorySelect.items.find((choice) => choice.value === categorySelect.value);

  strategySelect.items = strategySelect.items.map((choice) => ({
    ...choice,
    title: choice.dataset?.categoryLabelTemplate?.replace("{{category}}", item?.title || "") || choice.title,
  }));
}

/**
 * Saves CTA toggles, categories and strategies to `component` after every sp-select in `root` mounts.
 * The toggle stays disabled until then. Disabling CTA clears targeting; category picks update strategy labels.
 */
export function bindCtaSelects(root, component) {
  const checkbox = root.querySelector("input#cta");
  const wasDisabled = checkbox?.disabled;

  if (checkbox) {
    checkbox.disabled = true;
  }

  function bindSelects() {
    const categorySelect = root.querySelector(".cta-category-select");
    const strategySelect = root.querySelector(".replacement-strategy-select");

    function updateCategoryLabel() {
      relabelStrategies(root.querySelector(".cta-category-select"), root.querySelector(".replacement-strategy-select"));
    }

    function saveCtaCategory() {
      component.setCta(categorySelect.value);
      updateCategoryLabel();
      component.save();
    }

    categorySelect.addEventListener("change", saveCtaCategory);

    function saveReplacementStrategy() {
      component.data("replacement_strategy", strategySelect.value || false);
      component.save();

      updateCategoryLabel();
    }

    strategySelect.addEventListener("change", saveReplacementStrategy);

    function saveCtaToggle() {
      const checked = checkbox.checked;
      for (const options of root.querySelectorAll(".cta-options")) {
        options.style.display = checked ? "" : "none";
      }

      if (!checked) {
        const targeting = root.querySelector("input#targeting");

        if (targeting?.checked) {
          targeting.checked = false;
          const targetingOptions = root.querySelector(".targeting-options");

          if (targetingOptions) {
            targetingOptions.style.display = "none";
          }

          component.setTargeting(false);
        }
      }

      component.setCta(checked ? categorySelect.value : false);
      component.data("type", checked ? "CallToAction" : "Component");
      component.save();
    }

    if (checkbox) {
      checkbox.addEventListener("change", saveCtaToggle);
      checkbox.disabled = wasDisabled;
    }

    updateCategoryLabel();
  }

  return whenSelectsReady(root.querySelectorAll("sp-select"), bindSelects);
}
